import { FC } from 'react';
import { IconProps } from '../../types';

export const Iron2: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_57868)"
      />
      <path
        d="M4.63991 3.588H5.83991V11.988H4.63991V3.588ZM7.988 6.336H6.896C6.92 5.292 6.968 4.596 7.22 4.2C7.292 4.092 7.46 3.888 7.772 3.732C7.928 3.648 8.252 3.516 8.684 3.516C8.816 3.516 9.632 3.552 10.088 3.996C10.172 4.08 10.28 4.212 10.376 4.452C10.556 4.896 10.568 5.496 10.568 5.604C10.568 6.156 10.46 6.516 10.28 7.056C9.872 8.1 9.668 8.52 9.14 9.516L8.336 10.992H10.412V12H6.692L8.324 8.676C8.768 7.752 9.368 6.516 9.368 5.52C9.368 4.74 9.068 4.488 8.684 4.488C8.6 4.488 8.408 4.5 8.264 4.656C7.976 4.944 8.012 5.364 8 5.736C8 5.94 7.988 6.132 7.988 6.336Z"
        fill="#E3E3E3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_57868"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#402F2F" />
          <stop offset="0.239" stopColor="#68666F" />
          <stop offset="0.47" stopColor="#A8A2A2" />
          <stop offset="1" stopColor="#6C5858" />
        </linearGradient>
      </defs>
    </svg>
  );
};
